import React, { Component } from 'react';
import { debounce } from 'lodash';
import ApiService from '../../services/ApiService';
import dayjs from 'dayjs';
import {HorizontalBar} from 'react-chartjs-2';
import Pagination from 'react-js-pagination';
import {isMobile, isDesktop} from 'react-device-detect';
import Select from 'react-select';

class PostCrawledPosts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      trendingKeywords: {data:[]},
      trendingPosts: {data:[]},
      activePageTable: 1,
      itemsCountPerPageTable: 5,
      currentPage: 0,
      isLoading: false,
      isReachingEnd: false,
      error: null,
      source: null,
      pageSizeFilter: null,
      searchKeywordsValue: "",
      searchTableValue: "",
      showScrollTopButton: false,
      listNewspaper: [
        {slug: 'soha', name: 'Soha'},
        {slug: 'cafef', name: 'CafeF'},
        {slug: 'kenh14', name: 'Kenh14'},
        {slug: 'vnexpress', name: 'VnExpress'},
        {slug: 'vtv', name: 'VTV'},
        {slug: '24h', name: '24h'},
        {slug: 'thanhnien', name: 'Thanh Niên'},
        {slug: 'nguoilaodong', name: 'Người lao động'},
        {slug: 'ngoisao', name: 'Ngôi sao . net'},
        {slug: '2sao', name: '2sao'},
        {slug: 'znews', name: 'Znews'},
        {slug: 'eva', name: 'Eva'},
        {slug: 'danviet', name: 'Dân việt'}
      ],
    };
    this.tableCrawledPostRef = React.createRef();
    this.searchKeywordRef = React.createRef();
    this.lastPostRef = React.createRef(); // Create a ref for the last post
  }

  componentDidMount() {
    this.getListTrendingKeywords();
    this.getListTrendingPosts();
    this.getListPostCrawled();

    window.addEventListener('scroll', this.checkScrollTop);

    // Create an intersection observer
    this.observer = new IntersectionObserver(
        entries => {
          const first = entries[0];
          if (first.isIntersecting && !this.state.isReachingEnd) {
            this.handleLoadMore();
          }
        },
        // Options for the observer (which mutations to observe)
        {
          //intersection will trigger, not just when scroll
          root: null,
          rootMargin: '0px',
          threshold: 0.1
        }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    //handle the search keywords changed
    if(prevState.searchKeywordsValue !== this.state.searchKeywordsValue){
      this.setState({posts: [], currentPage: 0, isReachingEnd: false}, () => {
        this.getListPostCrawled();
      });
    }

    //handle the source changed
    if(prevState.source !== this.state.source){
      this.setState({posts: [], currentPage: 0, isReachingEnd: false}, () => {
        this.getListPostCrawled();
      });
    }

    //handle page size changed
    if(prevState.pageSizeFilter !== this.state.pageSizeFilter){
      this.setState({posts: [], currentPage: 0, isReachingEnd: false}, () => {
        this.getListPostCrawled();
      });
    }

    // If posts have been added, observe the last post
    if (prevState.posts.length !== this.state.posts.length) {
      if (this.lastPostRef.current) {
        this.observer.observe(this.lastPostRef.current);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.checkScrollTop);

    // Disconnect the intersection observer when the component is unmounted
    this.observer.disconnect();
  }

  checkScrollTop = () => {
    if (!this.state.showScrollTopButton && window.scrollY > window.innerHeight) {
      this.setState({ showScrollTopButton: true });
    } else if (this.state.showScrollTopButton && window.scrollY <= window.innerHeight) {
      this.setState({ showScrollTopButton: false });
    }
  };

  getListTrendingKeywords = async () => {
    try {
      const response = await ApiService.get('/crawler-magazine/trending-keyword')
      const result = {
        created_date: dayjs(response[0].created_date.$date).format('HH:mm DD/MM/YYYY'),
        data: JSON.parse(response[0].data)
      }

      this.setState({ trendingKeywords: result });
    } catch (error) {
      console.log('Error fetching trending keywords: ', error);
    }
  }

  getListTrendingPosts = async () => {
    try {
      const response = await ApiService.get('/crawler-magazine/trending-posts');
      const result = {
        created_date: dayjs(response[0].created_date.$date).format('HH:mm DD/MM/YYYY'),
        data: JSON.parse(response[0].data)
      }

      this.setState({ trendingPosts: result });
    } catch (error) {
      console.log('Error fetching trending posts: ', error);
    }
  }

  getListPostCrawled = debounce(async (pageNumber = this.state.currentPage) => {
        this.setState({ isLoading: true });

        try {
          const url = `/crawler-magazine/posts?pagesize=${this.state.pageSizeFilter || 10}&page=${pageNumber + 1}${this.state.source || (this.state.searchKeywordsValue !== '' && this.state.searchKeywordsValue !== null && this.state.searchKeywordsValue !== undefined) ? `&filter={${this.state.source ? `"newspaper":"${this.state.source}",` : ''}${this.state.searchKeywordsValue ? `"$text":{"$search":"\\"${this.state.searchKeywordsValue}\\""}` : ''}}` : ''}`;
          const response = await ApiService.get(url); // Assuming ApiService is available

          const newPosts = response.map((post) => ({
            ...post,
            _id: post._id.$oid,
            created_date: post.created_date.$date,
            publish_date: post.publish_date.$date,
          }));

          this.setState((prevState) => ({
            posts: prevState.posts.concat(newPosts),
            currentPage: pageNumber + 1,
            isLoading: false,
            isReachingEnd: newPosts.length < this.state.pageSizeFilter,
          }));
        } catch (error) {
          console.log('Error fetching posts: ', error);
          this.setState({ isLoading: false, error });
        }
      }
  , 500);

  handleLoadMore = () => {
    if (!this.state.isLoading && !this.state.isReachingEnd) {
      this.getListPostCrawled();
    }
  };

  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  handleSearch = (value) => {
    this.setState({
      searchKeywordsValue: this.validateInput(value),
    }, () => {
      this.tableCrawledPostRef.current.scrollIntoView({block: isMobile ? 'start' : 'center', behavior: 'smooth'});
    })
  }

  debouncedHandleSearch = value => {
    if(value === ''){
      debounce(this.handleSearch, 1000)
    }
  };

  handlePageChange(pageNumber) {
    this.setState({activePageTable: pageNumber});
  }

  validateInput = (e) => {
    //remove special characters from string input,
    // but not remove space and character like vietnamese
    const regex = /[^a-zA-Z0-9\s\u00C0-\u1EF9]/g;
    return e.replace(regex, '');
  }

  // ... other methods

  render() {
    const {
      source,
      posts,
      trendingPosts,
      trendingKeywords,
      isLoading,
      isReachingEnd,
      error,
      showScrollTopButton,
      activePageTable,
      itemsCountPerPageTable,
      listNewspaper,
      searchKeywordsValue,
    } = this.state;
    console.log({trendingKeywords, trendingPosts, posts});

    if(trendingPosts.data.length === 0 || trendingKeywords.data.length === 0) return <></>;

    // Calculate the index of the first and last items on the current page
    const indexOfLastItem = activePageTable * itemsCountPerPageTable;
    const indexOfFirstItem = indexOfLastItem - itemsCountPerPageTable;

    // Create a new array containing only the items on the current page
    const currentItems = trendingPosts.data.trending_article_list.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div className={'mt-5 px-3 position-relative'}>
          {/*search by keyword*/}
          <div className={'mt-5 mb-3 d-flex'}>
            <input
                className={'w-100 px-3 border rounded rounded-lg'}
                type="search"
                ref={this.searchKeywordRef}
                onKeyPress={(e) => e.key === 'Enter' && this.handleSearch(e.target.value)}
                onChange={(e) => this.debouncedHandleSearch(e.target.value)}
                placeholder={`Gợi ý: ${trendingKeywords.data.trending_keyword_list.map(keyword => keyword.keyword).join(' - ') || ''}`}
            />
            <button className={'btn btn-primary mx-2'}
                    onClick={() => this.handleSearch(this.searchKeywordRef.current.value)}
            >
              <i className="fas fa-search"></i>
            </button>
            <button className={'btn btn-danger'}
                    onClick={() => {
                      this.setState({searchKeywordsValue: ''});
                      this.searchKeywordRef.current.value = '';
                    }}
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          {/*Trending keywords*/}
          <div className="mb-4 mt-3 p-3 border rounded rounded-lg" style={{minHeight: '680px'}}>
            <HorizontalBar
                data={{
                  labels: trendingKeywords.data.trending_keyword_list.map(keyword => keyword.keyword),
                  datasets: [
                    {
                      label: 'Số lần xuất hiện từ khóa',
                      data: trendingKeywords.data.trending_keyword_list.map(
                          keyword => keyword.increase_freq),
                      backgroundColor: 'rgba(75, 192, 192, 0.2)',
                      borderColor: 'rgba(75, 192, 192, 1)',
                      borderWidth: 1,
                    }],
                }}
                options={{
                  scales: {
                    xAxes: [
                        {
                          ticks: {
                            beginAtZero: true,
                            max: Math.max(...trendingKeywords.data.trending_keyword_list.map(keyword => keyword.increase_freq)),
                          }
                        }
                    ],
                  },
                  title: {
                    display: true,
                    text: [`Từ khóa nổi bật ${!isMobile ? `được dùng xuất bản bài viết trong ${trendingKeywords.data.trending_duration}` : ''}`, `Updated at: ${trendingKeywords.created_date}`],
                    fontSize: isMobile ? 16 : 20,
                    lineHeight: 1.5,
                  },
                  legend: {
                    display: false,
                  },
                  event: ['click', 'dataPointSelection'],
                  onClick: (event, chartContext, config) => {
                    // if(isMobile || !chartContext.length) return;
                    const clickedCategory = chartContext[0]._chart.config.data.labels[chartContext[0]._index];
                    const confirmAlert = window.confirm(`Bạn muốn tìm kiếm bài viết với từ khóa: ${clickedCategory}`);
                    if(confirmAlert){
                      this.handleSearch(clickedCategory);
                      this.searchKeywordRef.current.value = clickedCategory;
                    }
                  },
                  maintainAspectRatio: false, //Maintain the original canvas aspect ratio (width / height) when resizing.
                }}
            />
          </div>

          {/*Trending posts*/}
          <div className="my-4 px-3 pt-3 border rounded rounded-lg">
            <h3 className={'mb-0'}>Bài viết nổi bật</h3>
            <p className={'text-xs font-light text-gray-800'}>Updated at: {trendingPosts.created_date}</p>
            <table className="table table-hover py-3">
              <thead>
              <tr>
                <th width={isMobile ? '80px' : '110px'}>Chủ đề</th>
                <th>Tiêu đề</th>
                {!isMobile &&
                    <th width={'100px'}>Nguồn</th>
                }
                <th width={isMobile ? '80px' : '125px'}>Cập nhật</th>
              </tr>
              </thead>
              <tbody>
              {currentItems.map((post) => (
                  <tr key={post._id}>
                    <td>{post.keyword}</td>
                    <td>
                      <a className={'text-primary'} href={post.href} target={'_blank'}>{post.topic}</a>
                    </td>
                    {!isMobile &&
                        <td>{post.newspaper}</td>
                    }
                    <td>
                      {isMobile &&
                        <p className={'text-primary mb-0'}>
                          {post.newspaper}
                        </p>
                      }
                      {post.update_time}
                    </td>
                  </tr>
              ))}
              </tbody>
            </table>
            <div className={'d-flex justify-content-center'}>
              <Pagination
                  activePage={activePageTable}
                  itemsCountPerPage={itemsCountPerPageTable}
                  totalItemsCount={trendingPosts.data.trending_article_list.length}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  prevPageText={'<'}
                  nextPageText={'>'}
                  hideFirstLastPages={true}
                  itemClass={'btn btn-default mx-1 text-primary'}
              />
            </div>
          </div>

          {/* Posts*/}
          <div className={'d-flex align-items-center mt-4'}>
            {/*options source newspaper*/}
            <Select
                className="basic-single w-100 mr-2"
                classNamePrefix="select"
                placeholder={'Nguồn báo'}
                isClearable={true}
                isSearchable={true}
                name="color"
                options={[{value: null, label: 'Tất cả nguồn báo'}].concat(listNewspaper.map(item => ({value: item.slug, label: item.name})))}
                onChange={(selectedOption) => {
                  if (!selectedOption) {
                    return this.setState({ source: null });
                  }
                  if(selectedOption.value === null){
                    return this.setState({ source: null });
                  }
                  this.setState({ source: selectedOption.label });
                }}
            />

            {/*options pagezie*/}
            <Select
                className="basic-single w-100"
                classNamePrefix="select"
                placeholder={'Pages size'}
                isSearchable={false}
                name="pageSize"
                options={[
                  {value: 10, label: 10},
                  {value: 20, label: 20},
                  {value: 50, label: 50},
                  {value: 100, label: 100},
                  {value: 200, label: 200},
                  {value: 500, label: 500},
                  {value: 1000, label: 1000},
                ]}
                onChange={(selectedOption) => {
                  if (!selectedOption) {
                    this.setState({ pageSizeFilter: null });
                  } else {
                    this.setState({ pageSizeFilter: selectedOption.value });
                  }
                }}
            />
          </div>

          <div ref={this.tableCrawledPostRef}
               className={'mb-5 mt-1 p-3 border rounded rounded-lg'}>
            <h3>
              Danh sách bài viết
              {source ?
                  <span> từ nguồn <span
                      className={'text-primary'}>{source}</span></span> :
                  ''}
              {searchKeywordsValue ?
                  <span
                      onClick={() => this.searchKeywordRef.current.scrollIntoView(
                          {
                            block: 'end',
                            behavior: 'smooth'
                          })}> với từ khóa <span
                      className={'text-primary cursor-pointer'}>#{searchKeywordsValue}</span></span> :
                  ''}
            </h3>
            {/*{isMobile ?*/}
            {/*    <table className="table table-hover py-3">*/}
            {/*      <thead>*/}
            {/*      <tr>*/}
            {/*        <th width={'110px'}><span style={{whiteSpace: 'nowrap'}}>Xuất bản</span>*/}
            {/*        </th>*/}
            {/*        <th>Tên bài viết</th>*/}
            {/*      </tr>*/}
            {/*      </thead>*/}
            {/*      <tbody>*/}
            {/*      {posts.length === 0 && <tr>*/}
            {/*        <td colSpan={4}>There is nothing to display.</td>*/}
            {/*      </tr>}*/}
            {/*      {error && <tr>*/}
            {/*        <td colSpan={4}>Error... Please try in few minutes!</td>*/}
            {/*      </tr>}*/}
            {/*      {posts.map((post, index) => <tr key={post._id}>*/}
            {/*            <td>*/}
            {/*              <a className={'text-primary'}*/}
            {/*                 href={post.href}*/}
            {/*                 target={'_blank'}*/}
            {/*              >*/}
            {/*                {post.newspaper}*/}
            {/*              </a>*/}
            {/*              <p className={'mb-0'}>*/}
            {/*                {dayjs(post.publish_date).format('HH:mm DD/MM')}*/}
            {/*              </p>*/}
            {/*            </td>*/}
            {/*            <td>*/}
            {/*              <a className={'text-primary'} href={post.href}*/}
            {/*                 target={'_blank'}>{post.topic}</a>*/}
            {/*            </td>*/}
            {/*          </tr>*/}
            {/*      )}*/}
            {/*      </tbody>*/}
            {/*      <tfoot ref={this.lastPostRef} className={'pt-1'}></tfoot>*/}
            {/*    </table> :*/}
            {/*    */}
            {/*}*/}
            <div className={'w-100 d-flex flex-column'}>
              {posts.map((post, index) =>
                  <div className={`py-3 border-bottom d-flex ${index === 0 ?
                      'border-top' :
                      ''}`} key={post._id}>
                    <img src={post.feature_image}
                         className={`${isMobile ? 'mr-2' : 'mr-3'} rounded-lg`}
                         style={{
                           width: isMobile ? '100px' : '120px',
                           height: isMobile ? '56px' : '68px',
                           objectFit: 'cover',
                           objectPosition: 'center',
                         }}
                    />
                    <div className={'d-flex flex-column'}>
                      <a className={`text-primary mb-1 ${isMobile ?
                          'text-sm' :
                          'text-lg'}`}
                         href={post.href}
                         target={'_blank'}>{post.topic}
                      </a>
                      <div className={'d-flex align-items-center'}>
                        <a className={`text-secondary mr-3 ${isMobile ? 'text-sm' : 'text-md'}`}
                           href={post.href}
                           target={'_blank'}
                        >
                          {post.newspaper}
                        </a>
                        <p className={`mb-0 text-secondary ${isMobile ? 'text-sm' : ''}`}>
                          {dayjs(post.publish_date).format('HH:mm DD/MM')}
                        </p>
                      </div>
                    </div>
                  </div>,
              )}
              <span ref={this.lastPostRef} className={'pt-1'}></span>
            </div>
            {isReachingEnd && (
                <div>No more posts to load</div>
            )}
            {isLoading && <p className={'text-center'}>
              Loading...
            </p>}
          </div>

          {/*scroll to top*/}
          {showScrollTopButton && (
              <button onClick={this.scrollToTop}
                      className="scroll-top-button position-fixed btn btn-primary rounded-xl"
                      style={{bottom: '20px', right: '20px'}}>
                <i className="fas fa-chevron-up"></i>
              </button>
          )}
        </div>
    );
  }
}

export default PostCrawledPosts;